export default "__VITE_ASSET__Re7Tw7R7__"